var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.config
    ? _c(
        "div",
        { key: _setup.elementKey, staticClass: "calendar-section" },
        [
          _c(_setup.CInput, {
            attrs: {
              value: Number(_setup.config.borderRadius),
              type: "decimal",
              step: ".1",
              min: 0,
              label: "Border Radius",
              disabled: _setup.disabled,
            },
            on: {
              input: function ($event) {
                _setup.update({ borderRadius: String($event) })
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.CalendarStrokeField, {
            attrs: {
              title: "Calendar Stroke",
              width: _setup.config.BGBorderWidth,
              color: _setup.config.BGBorderColor,
              disabled: _setup.disabled,
            },
            on: { update: _setup.onStrokeUpdate },
          }),
          _vm._v(" "),
          _c(_setup.CalendarFieldTitle, [_vm._v("Background")]),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            attrs: {
              value: _setup.config.useSingleBG,
              "no-icon": "",
              type: "radio",
              wide: "",
              items: _setup.BACKGROUND_MODES,
              disabled: _setup.disabled,
            },
            on: {
              input: function ($event) {
                return _setup.update({ useSingleBG: $event })
              },
            },
          }),
          _vm._v(" "),
          _setup.config.useSingleBG
            ? _c(_setup.CalendarColorField, {
                attrs: {
                  value: _setup.config.singleBGColor,
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update({ singleBGColor: $event })
                  },
                },
              })
            : _vm._l(_setup.SEPARATE_BACKGROUNDS, function (background) {
                return _c(_setup.CalendarColorField, {
                  key: background.key,
                  attrs: {
                    title: background.title,
                    value: _setup.config[background.key],
                    disabled: _setup.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.update({ [background.key]: $event })
                    },
                  },
                })
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }